import { defineStore } from "pinia";

export const useSwajarKurikulumStore = defineStore({
  id: "swajarKurikulum",
  state: () => ({
    materiType: "k1",

    loadingValidateMateriK2Access: false,
    errorValidateMateriK2Access: "",
    validAccess: false,

    loadingGetSertifikatK1: false,
    errorGetSertifikatK1: false,
    sertifikatK1: {},

    loadingGetSertifikatK2: false,
    errorGetSertifikatK2: false,
    sertifikatK2: {},

    loadingGetJournal: false,
    errorGetJournal: false,
    journalData: {},

    loadingGetRangkuman: false,
    errorGetRangkuman: false,
    rangkumanList: [],

    loadingGetRangkumanById: {},
    rangkumanByIdData: {},

    loadingSaveRangkuman: {},
  }),
  actions: {
    async validateMateriK2Access() {
      this.loadingValidateMateriK2Access = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/swajar-cache-reader/api/progressmateri/v2/validasiAksesMateriKdua/${uuidCourse}`,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.validAccess = response?.status || false;
          state.errorValidateMateriK2Access = "";
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useSwajarKurikulumStore().$patch((state) => {
            state.errorValidateMateriK2Access =
              !!error?.response && !error?.response?._data?.status
                ? "materi"
                : "general";
          });
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
            isRevamp: true,
          });
        }
      } finally {
        this.loadingValidateMateriK2Access = false;
      }
    },
    async getSertifikatK1(angkatanId) {
      this.loadingGetSertifikatK1 = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/dashboard-profile/api/sertifikat/getByAngkatanAndUser/${angkatanId}`,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.sertifikatK1 = response || {};
        });
        this.errorGetSertifikatK1 = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetSertifikatK1 = true;
        }
      } finally {
        this.loadingGetSertifikatK1 = false;
      }
    },
    async getSertifikatK2(angkatanId) {
      this.loadingGetSertifikatK2 = true;
      const event = useRequestEvent();
      try {
        const response = await fetchBelajarWajib(
          event,
          `/dashboard-profile/api/sertifikat/kdua/getByAngkatanAndUser/${angkatanId}`,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.sertifikatK2 = response || {};
        });
        this.errorGetSertifikatK2 = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetSertifikatK2 = true;
        }
      } finally {
        this.loadingGetSertifikatK2 = false;
      }
    },
    async getJournal() {
      this.loadingGetJournal = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/swajar-cache-reader/api/jurnal${this.materiType === "k2" ? "_kurikulum_dua" : ""}/v2/jurnalByUuidCourse/${uuidCourse}`,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.journalData = response || {};
        });
        this.errorGetJournal = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetJournal = true;
        }
      } finally {
        this.loadingGetJournal = false;
      }
    },
    async getRangkuman() {
      this.loadingGetRangkuman = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const masterTypeId = courseData?.angkatan?.masterTypes?.id || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/swajar-cache-reader/api/jurnal-materi${this.materiType === "k2" ? "-kdua" : ""}/v2/list-nested/${uuidCourse}/${masterTypeId} `,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.rangkumanList = response || [];
        });
        this.errorGetRangkuman = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetRangkuman = true;
        }
      } finally {
        this.loadingGetRangkuman = false;
      }
    },
    async getRangkumanById(id) {
      this.loadingGetRangkumanById[id] = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/swajar-cache-reader/api/jurnal-materi${this.materiType === "k2" ? "-kdua" : ""}/v2/byCourseAndMateri/${uuidCourse}/${id} `,
          "GET",
        );
        useSwajarKurikulumStore().$patch((state) => {
          state.rangkumanByIdData = response || {};
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useSwajarKurikulumStore().$patch((state) => {
            state.rangkumanByIdData = {};
          });
        }
      } finally {
        this.loadingGetRangkumanById[id] = false;
      }
    },
    async saveRangkuman(data, payload, type) {
      this.loadingSaveRangkuman[data.id] = true;
      try {
        await fetchBelajarWajib(
          useRequestEvent(),
          `/jurnal-swajar/api/v2/jurnal-materi${this.materiType === "k2" ? "-kdua" : ""}/${type === "add" ? "save" : `${data.jurnalMateri.id}`}`,
          type === "add" ? "POST" : "PUT",
          payload,
        );
        useAuthStore().$patch({
          snackStatus: "positive",
          snackbar: true,
          messageSnack: "Rangkuman berhasil disimpan.",
          isRevamp: true,
        });
        await useSwajarKurikulumStore().getRangkuman();
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useAuthStore().$patch({
            snackStatus: "destructive",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
            isRevamp: true,
          });
        }
      } finally {
        this.loadingSaveRangkuman[data.id] = false;
      }
    },
  },
});
